import { Slider } from '../modules/slider';
import { TextPopup } from '../modules/textPopup';

const teamSections = document.querySelectorAll('.team');
if (teamSections.length > 0) {
    const activeFilterClass = '-active';

    const handleFilter = async (
        e,
        filterButtons,
        section,
        slider,
        popup,
        membersToExclude = []
    ) => {
        if (!section || !slider) return;
        const { target } = e;

        filterButtons.forEach(item => item.classList.remove(activeFilterClass));
        target.classList.add(activeFilterClass);
        const cardsWrapper = section.querySelector('.team__list');
        cardsWrapper.innerHTML = '';
        const loader = section.querySelector('.loader');
        loader.classList.add('-active');

        try {
            const categoryToFetch = target.getAttribute('data-category-term');
            const formData = new FormData();
            formData.append('categoryToFetch', categoryToFetch);
            formData.append('action', 'fetch_team');
            if (
                membersToExclude &&
                membersToExclude.length > 0 &&
                membersToExclude != 'false'
            )
                formData.append('membersToExclude', membersToExclude);

            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            const { html } = await req.json();

            if (html) {
                cardsWrapper.innerHTML = html;
                cardsWrapper.parentElement.classList.remove('-section-hide');
                handleBioClick(section.querySelectorAll('.team__item'), popup);
                slider.reinit();
            }
        } catch (error) {
            console.log(`Error: ${error}`);
        } finally {
            loader.classList.remove('-active');
        }
    };

    const handlePopup = (card, popup) => {
        const title = card.querySelector('.card-team-member__title');
        const position = card.querySelector('.card-team-member__position');
        const image = card.querySelector('.card-team-member__image');
        const bio = card.querySelector('.card-team-member__bio');
        popup = new TextPopup({
            card: card,
            name: title && title.textContent ? title.textContent : null,
            position:
                position && position.textContent ? position.textContent : null,
            bio: bio.innerHTML || null,
            image:
                {
                    alt: image.alt,
                    title: image.title,
                    src: image.src,
                } || null,
        });
    };

    const handleBioClick = (cards, popup) => {
        if (!cards) return;
        cards.forEach(card => {
            const bioButton = card.querySelector(
                '.card-team-member__bio-button'
            );
            if (bioButton)
                bioButton.addEventListener('click', () =>
                    handlePopup(card, popup)
                );
        });
    };

    teamSections.forEach(section => {
        const filterButtons = section.querySelectorAll('.team__filters-button');
        const cardsList = section.querySelector('.team__list');
        const cards = section.querySelectorAll('.team__item');
        if (cards.length === 0) return;

        let popup = null;
        let slider = null;
        const membersToExclude = section.getAttribute(
            'data-members-to-exclude'
        );

        slider = new Slider({
            el: section,
            breakpoints: {
                0: {
                    slidesPerView: 1.35,
                    marginRight: 8,
                },
                992: {
                    destroy: true,
                },
            },
        });

        if (filterButtons.length > 0) {
            filterButtons.forEach(button => {
                button.addEventListener('click', e => {
                    cardsList.parentElement.classList.add('-section-hide');
                    setTimeout(() => {
                        handleFilter(
                            e,
                            filterButtons,
                            section,
                            slider,
                            popup,
                            membersToExclude
                        );
                    }, 200);
                });
            });
        }

        handleBioClick(cards, popup);
    });
}
